export default __webpack_public_path__ + "static/media/upInActive.8573e9a3.svg";